import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { MIN_SELECTION, MAX_SELECTION } from './utils'

export interface AdCountSelectorProps {
  count: number
  onCountChange: (count: number) => void
  min?: number
  max?: number
  disabled?: boolean
  label?: string
}

export function AdCountSelector({
  count,
  onCountChange,
  min = MIN_SELECTION,
  max = MAX_SELECTION,
  disabled = false,
  label = 'Number of references:',
}: AdCountSelectorProps) {
  const handleDecrement = () => {
    if (count > min) {
      onCountChange(count - 1)
    }
  }

  const handleIncrement = () => {
    if (count < max) {
      onCountChange(count + 1)
    }
  }

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-gray-600">{label}</span>
      <div className="flex items-center gap-1">
        <button
          onClick={handleDecrement}
          disabled={disabled || count <= min}
          className={cn(
            'w-7 h-7 rounded flex items-center justify-center border transition-colors',
            disabled || count <= min
              ? 'border-gray-200 text-gray-300 cursor-not-allowed'
              : 'border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400'
          )}
        >
          <Minus className="w-4 h-4" />
        </button>
        <span className="w-8 text-center font-medium text-gray-900">{count}</span>
        <button
          onClick={handleIncrement}
          disabled={disabled || count >= max}
          className={cn(
            'w-7 h-7 rounded flex items-center justify-center border transition-colors',
            disabled || count >= max
              ? 'border-gray-200 text-gray-300 cursor-not-allowed'
              : 'border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400'
          )}
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <span className="text-xs text-gray-400">({min}-{max})</span>
    </div>
  )
}
